import { ContentType, request } from "../api";

import { baseParams } from "../common";

export const getTransactions = async (data = {}, params = {}) => request({
  path: "/transactions",
  method: "POST",
  secure: true,
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
